﻿import {withCapitalized} from "../../../../hocs/withCapitalized";
import {CardItemLabel} from "../CardItemLabel";

export const CardItemLabelWithCapitalized = withCapitalized(CardItemLabel);
